module.exports = __webpack_public_path__ + "static/media/maintenance2.235c742f.png";